/* Pet Nugget theme — global.js
 * Purchase state (dog weight → jars, one-time vs subscription), purchase panels,
 * gallery, accordion, reviews filtering, ingredient loop, blog load-more, toast.
 * No dependencies. Runs after DOM parse (loaded with defer). */
(function () {
  'use strict';
  var PN = window.PN || (window.PN = {});
  var PlanUtils = window.PNPlanUtils;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  PN.$ = $; PN.$$ = $$;

  /* ---------------- Money ---------------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var formatString = format || PN.moneyFormat || '${{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision; thousands = thousands || ','; decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var m = formatString.match(placeholder);
    var value;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return formatString.replace(placeholder, value);
  }
  PN.money = formatMoney;

  /* ---------------- Toast ---------------- */
  var toastTimer;
  PN.toast = function (text) {
    var el = $('#pn-toast'); if (!el) return;
    var t = el.querySelector('[data-toast-text]'); if (t) t.textContent = text;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 3500);
  };
  PN.hideToast = function () { var el = $('#pn-toast'); if (el) el.hidden = true; };

  /* ---------------- Purchase state ---------------- */
  var KEY = 'pn-purchase-v2';
  var pstate = { size: 'medium', sub: true, months: 2 };
  try {
    var saved = JSON.parse(localStorage.getItem(KEY) || '{}');
    if (saved && typeof saved === 'object') {
      if (typeof saved.sub === 'boolean') pstate.sub = saved.sub;
      if ([1, 2, 3].indexOf(saved.months) >= 0) pstate.months = saved.months;
      if ((PN.sizes || []).some(function (s) { return s.key === saved.size; })) pstate.size = saved.size;
    }
  } catch (e) {}
  var plisteners = [];
  function setP(patch) {
    Object.keys(patch).forEach(function (k) { pstate[k] = patch[k]; });
    try { localStorage.setItem(KEY, JSON.stringify(pstate)); } catch (e) {}
    plisteners.forEach(function (fn) { fn(pstate); });
  }
  function sizeInfo(key) {
    var sizes = PN.sizes || [];
    for (var i = 0; i < sizes.length; i++) if (sizes[i].key === key) return sizes[i];
    return sizes[0] || { key: 'small', label: 'Under 25 lb', jars: 1, chews: 1, daysPerJar: 60 };
  }
  var SUPPLY_DAYS = {
    small: [60, 120, 180],
    medium: [60, 90, 120],
    large: [60, 100, 120]
  };
  var SUPPLY_JARS = {
    small: [1, 2, 3],
    medium: [2, 3, 4],
    large: [3, 5, 6]
  };
  var TIER_DISCOUNTS = [15, 25, 33];
  var Discounts = window.PNDiscounts;
  function planDays(plan) { return PlanUtils ? PlanUtils.planDays(plan) : null; }
  function pickPlan(product, days, pct, price) { return PlanUtils ? PlanUtils.findPlan(product, days, pct, price) : null; }
  function discountPercent(plan, price) { return PlanUtils ? PlanUtils.discountPercent(plan, price) : 0; }
  function percentLabel(value) { return PlanUtils ? PlanUtils.formatPercent(value) : Math.round(value) + '%'; }
  function plural(n, one, many) { return n + ' ' + (n === 1 ? one : many); }
  function packageSpec(sizeKey, tier) {
    var days = SUPPLY_DAYS[sizeKey] || SUPPLY_DAYS.small;
    var jars = SUPPLY_JARS[sizeKey] || SUPPLY_JARS.small;
    var index = Math.max(0, Math.min(2, Number(tier || 1) - 1));
    return { tier: index + 1, days: days[index], jars: jars[index], discount: days[index] === 120 ? 25 : TIER_DISCOUNTS[index] };
  }
  function discountForSupply(sizeKey, days) {
    var options = SUPPLY_DAYS[sizeKey] || [];
    var index = options.indexOf(Number(days));
    return index >= 0 ? (Number(days) === 120 ? 25 : TIER_DISCOUNTS[index]) : null;
  }
  function oneTimeDiscountForSupply(sizeKey, days) {
    var options = SUPPLY_DAYS[sizeKey] || [];
    var index = options.indexOf(Number(days));
    return index >= 0 ? Discounts.percent((SUPPLY_JARS[sizeKey] || SUPPLY_JARS.small)[index]) : 0;
  }
  function oneTimeDiscountCode(percent) {
    var codes = PN.oneTimeDiscountCodes || {};
    return codes[String(Math.round(Number(percent) || 0))] || '';
  }

  function compute(product) {
    var sz = sizeInfo(pstate.size);
    var months = pstate.months || 1;
    var price = product ? product.price : 0;
    var plans = product && product.sellingPlans || [];
    var hasPlans = plans.length > 0;
    var previewPct = Number(PN.subscriptionPreviewPercent || 0);
    var previewOnly = !hasPlans && previewPct > 0;
    var subAvailable = hasPlans || previewOnly;
    var sub = !!pstate.sub && subAvailable;
    var jarWord = PN.strings ? PN.strings.jar : 'jar', jarsWord = PN.strings ? PN.strings.jars : 'jars';
    var strings = PN.strings || {};
    var packages = [1, 2, 3].map(function (n) {
      var spec = packageSpec(sz.key, n);
      var j = spec.jars;
      var days = spec.days;
      var plan = pickPlan(product, days, spec.discount, price);
      var cadence = plan ? (planDays(plan) || days) : days;
      var subscriptionPct = plan ? discountPercent(plan, price) : previewOnly ? spec.discount : 0;
      var oneTimePct = Discounts.percent(j);
      var pct = sub ? subscriptionPct : oneTimePct;
      var available = !sub || !!plan || previewOnly;
      var oneTimeUnit = Math.round(price * (100 - oneTimePct) / 100);
      var each = sub && available ? (plan ? plan.price : Math.round(price * (100 - pct) / 100)) : oneTimeUnit;
      return {
        n: n, title: days + '-day supply', selected: months === n,
        sub: plural(j, jarWord, jarsWord) + ' · ' + formatMoney(Math.round((each * j) / days)) + ' per day',
        jars: j, days: days, cadence: cadence, unit: each, total: each * j,
        plan: plan, planId: plan ? plan.id : null, available: available,
        savePercent: pct, price: formatMoney(each * j), was: formatMoney(price * j),
        oneTimeDiscountPercent: oneTimePct, oneTimeDiscountCode: oneTimeDiscountCode(oneTimePct), oneTimeUnit: oneTimeUnit,
        hasSave: available && pct > 0, save: 'Save ' + percentLabel(pct),
        popular: sub && n === 2 && available, best: sub && n === 3 && available,
        line1: sub && available ? 'Shipped and billed every ' + cadence + ' days · skip, pause, or cancel anytime' : 'Ships once · ' + days + ' days of chews',
        shippingLine: sub && available ? 'Free shipping on all subscription orders' : 'Free shipping on one-time orders over ' + formatMoney(PN.freeShippingThreshold || 0)
      };
    });
    var selected = packages[months - 1] || packages[0];
    var jars = selected.jars;
    var orderDays = selected.days;
    var plan = selected.plan;
    var cadence = selected.cadence;
    var savePct = selected.savePercent;
    var unit = selected.unit;
    var subPrice = sub ? unit : (plan ? plan.price : Math.round(price * (100 - previewPct) / 100));
    var oneTimeTotal = selected.oneTimeUnit * jars;
    var jarsLabel = plural(jars, jarWord, jarsWord);
    var canPurchase = !sub || !!plan;
    return {
      size: pstate.size, sizeLabel: sz.label, sizeLabelLower: sz.label.toLowerCase(), months: months, jars: jars, jarsLabel: jarsLabel,
      orderDays: orderDays, cadence: cadence, sub: sub, subAvailable: subAvailable, hasPlan: !!plan, hasPlans: hasPlans,
      canPurchase: canPurchase, planId: plan ? plan.id : null, planName: plan ? plan.name : '',
      price: price, subPrice: subPrice, unit: unit, total: unit * jars,
      totalLabel: formatMoney(unit * jars), subTotalLabel: formatMoney(subPrice * jars), oneTotalLabel: formatMoney(oneTimeTotal),
      saveLabel: formatMoney((price - unit) * jars), savePercent: percentLabel(savePct), savePercentLabel: 'Save ' + percentLabel(savePct),
      subscribeSavePercent: percentLabel(sub ? savePct : TIER_DISCOUNTS[2]), subscribeSavePercentLabel: 'Save ' + percentLabel(sub ? savePct : TIER_DISCOUNTS[2]),
      oneTimeDiscountPercent: selected.oneTimeDiscountPercent, oneTimeDiscountCode: selected.oneTimeDiscountCode,
      atcLabel: sub ? (canPurchase ? (strings.startSubscription || 'Start subscription') : 'Subscription unavailable') : (strings.addToCart || 'Add to cart'),
      supplyNote: jarsLabel + ' · ' + orderDays + '-day supply for a dog ' + sz.label.toLowerCase() + (sub ? ' · renews every ' + cadence + ' days' : ''),
      servingNote: plural(sz.chews, 'chew', 'chews') + ' daily · ' + sz.jars + (sz.jars === 1 ? ' jar is' : ' jars are') + ' a ' + (sz.daysPerJar * sz.jars) + '-day supply',
      shipsEvery: 'ships every ' + cadence + ' days',
      cadenceShort: sub ? 'every ' + cadence + ' days' : (strings.oneTime || 'one-time'),
      freeShippingThreshold: formatMoney(PN.freeShippingThreshold || 0),
      pkgTypeNote: sub ? 'Save ' + percentLabel(savePct) + ' on this supply and get free shipping.' : (savePct ? 'Save ' + percentLabel(savePct) + ' with this volume tier. ' : '') + 'Subscribe to save up to 33% and get free shipping. One-time orders ship free over ' + formatMoney(PN.freeShippingThreshold || 0) + '.',
      pkgWasTotal: formatMoney(price * jars),
      packages: packages
    };
  }
  PN.purchase = {
    state: pstate,
    set: setP,
    on: function (fn) { plisteners.push(fn); },
    compute: compute,
    sizeInfo: sizeInfo,
    discountForSupply: discountForSupply,
    oneTimeDiscountForSupply: oneTimeDiscountForSupply,
    planDays: planDays,
    planForSupply: pickPlan
  };

  /* ---------------- Ajax add to cart ---------------- */
  function postJSON(url, body) {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', url, true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.onload = function () {
        var json;
        try { json = JSON.parse(xhr.responseText); } catch (e) { json = { message: xhr.statusText || 'Invalid cart response' }; }
        if (xhr.status >= 200 && xhr.status < 300) resolve(json); else reject(json);
      };
      xhr.onerror = function () { reject({ message: 'Unable to reach the cart.' }); };
      xhr.send(JSON.stringify(body));
    });
  }
  function getJSON(url) {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open('GET', url + (url.indexOf('?') >= 0 ? '&' : '?') + '_=' + Date.now(), true);
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.onload = function () {
        var json;
        try { json = JSON.parse(xhr.responseText); } catch (e) { json = { message: xhr.statusText || 'Invalid cart response' }; }
        if (xhr.status >= 200 && xhr.status < 300) resolve(json); else reject(json);
      };
      xhr.onerror = function () { reject({ message: 'Unable to reach the cart.' }); };
      xhr.send();
    });
  }
  function discountProductIds() {
    return $$('[data-pn-product]').map(function (el) {
      try { return JSON.parse(el.textContent).id; } catch (e) { return null; }
    }).filter(Boolean);
  }
  function volumeDiscountPercentFromCart(cart) {
    return Discounts.percent(Discounts.quantity(cart, discountProductIds()));
  }
  PN.syncVolumeDiscount = function (cart) {
    function apply(current) {
      var change = Discounts.update(current, discountProductIds(), PN.oneTimeDiscountCodes);
      return change === null ? Promise.resolve(current) :
        postJSON((PN.routes.cartUpdate || '/cart/update') + '.js', { discount: change });
    }
    return cart ? apply(cart) : getJSON((PN.routes.cart || '/cart') + '.js').then(apply);
  };
  PN.volumeDiscountPercentFromCart = volumeDiscountPercentFromCart;
  PN.addItem = function (item) {
    return Discounts.applyCampaignDiscount(window).then(function () {
      return postJSON((PN.routes.cartAdd || '/cart/add') + '.js', { items: [item] });
    }).then(function (res) {
      return PN.syncVolumeDiscount().then(function (updatedCart) {
        document.dispatchEvent(new CustomEvent('pn:cart-added', { detail: { added: res, cart: updatedCart } }));
        return res;
      });
    });
  };
  PN.cartError = function (err) {
    var msg = (err && (err.description || err.message)) || (PN.strings && PN.strings.cartError) || 'Something went wrong.';
    PN.toast(msg);
    if (window.console) console.warn('[Pet Nugget] cart error', err);
  };

  /* ---------------- Purchase panels ---------------- */
  function initPanel(root) {
    var productEl = root.querySelector('[data-pn-product]');
    var product = null;
    try { product = productEl ? JSON.parse(productEl.textContent) : null; } catch (e) {}
    var form = root.querySelector('[data-pn-form]');

    function render() {
      var d = compute(product);
      $$('[data-bind]', root).forEach(function (el) {
        var k = el.getAttribute('data-bind');
        if (k in d) el.textContent = d[k];
      });
      $$('[data-size]', root).forEach(function (b) {
        var on = b.getAttribute('data-size') === d.size;
        b.classList.toggle('is-selected', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      $$('[data-type]', root).forEach(function (b) {
        var on = (b.getAttribute('data-type') === 'sub') === d.sub;
        b.classList.toggle('is-selected', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      $$('[data-package]', root).forEach(function (el) {
        var pkg = d.packages[(parseInt(el.getAttribute('data-package'), 10) || 1) - 1];
        if (!pkg) return;
        el.classList.toggle('is-selected', pkg.selected);
        el.setAttribute('aria-pressed', pkg.selected ? 'true' : 'false');
        el.disabled = !pkg.available;
        $$('[data-package-bind]', el).forEach(function (target) {
          var key = target.getAttribute('data-package-bind');
          if (key in pkg) target.textContent = pkg[key];
        });
        var save = el.querySelector('[data-package-save]'); if (save) save.hidden = !pkg.hasSave;
        var was = el.querySelector('[data-package-was]'); if (was) was.hidden = !pkg.hasSave;
        var popular = el.querySelector('[data-package-popular]'); if (popular) popular.hidden = !pkg.popular;
        var best = el.querySelector('[data-package-best]'); if (best) best.hidden = !pkg.best;
        var details = el.querySelector('[data-package-details]'); if (details) details.hidden = !pkg.selected;
      });
      $$('[data-sub-option]', root).forEach(function (el) { el.hidden = !d.subAvailable; });
      if (form) {
        var qty = form.querySelector('[data-pn-qty]'); if (qty) qty.value = d.jars;
        var plan = form.querySelector('[data-pn-plan]');
        if (plan) {
          var previousPlan = plan.value;
          if (d.sub && d.planId) { plan.value = d.planId; plan.disabled = false; } else { plan.value = ''; plan.disabled = true; }
          if (previousPlan !== plan.value) plan.dispatchEvent(new Event('change', { bubbles: true }));
        }
        var prop = form.querySelector('[data-pn-size-prop]'); if (prop) prop.value = 'Dog weight: ' + d.sizeLabel;
        var supplyProp = form.querySelector('[data-pn-supply-prop]'); if (supplyProp) supplyProp.value = d.orderDays;
        var submit = form.querySelector('[data-pn-submit]'); if (submit) submit.disabled = product && product.available === false || !d.canPurchase;
      }
    }

    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-size],[data-type],[data-months]');
      if (!b || !root.contains(b)) return;
      if (b.hasAttribute('data-size')) setP({ size: b.getAttribute('data-size') });
      else if (b.hasAttribute('data-type')) setP({ sub: b.getAttribute('data-type') === 'sub' });
      else setP({ months: parseInt(b.getAttribute('data-months'), 10) || 1 });
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        if (!window.XMLHttpRequest) return; // no-JS fallback: normal POST to /cart/add
        e.preventDefault();
        var d = compute(product);
        var idEl = form.querySelector('[data-pn-variant]');
        if (!d.canPurchase) return;
        var item = { id: parseInt(idEl ? idEl.value : (product && product.variantId), 10), quantity: d.jars, properties: { _dog_size: 'Dog weight: ' + d.sizeLabel, _supply_days: String(d.orderDays) } };
        if (d.sub && d.planId) item.selling_plan = String(d.planId);
        else if (d.oneTimeDiscountPercent) item.properties._volume_discount = String(d.oneTimeDiscountPercent);
        var btn = form.querySelector('[type="submit"]'); if (btn) btn.disabled = true;
        PN.addItem(item).catch(PN.cartError).then(function () { if (btn) btn.disabled = false; });
      });
    }

    PN.purchase.on(render);
    render();
  }
  $$('[data-purchase]').forEach(initPanel);

  /* The full cart form must recalculate quantity savings before leaving for checkout. */
  var cartForm = $('.cart-page__form');
  if (cartForm) {
    var cartSubmitting = false;
    cartForm.addEventListener('submit', function (event) {
      event.preventDefault();
      if (cartSubmitting) return;
      cartSubmitting = true;
      var checkout = event.submitter && event.submitter.name === 'checkout';
      var quantities = $$('input[name="updates[]"]', cartForm).map(function (input) { return Math.max(0, Math.floor(Number(input.value) || 0)); });
      postJSON((PN.routes.cartUpdate || '/cart/update') + '.js', { updates: quantities })
        .then(PN.syncVolumeDiscount)
        .then(function () {
          if (checkout) window.location.assign((PN.routes.root || '/').replace(/\/$/, '') + '/checkout');
          else window.location.reload();
        })
        .catch(function (error) { cartSubmitting = false; PN.cartError(error); });
    });
    // Also reconcile carts returned from native remove links or another sales page.
    getJSON((PN.routes.cart || '/cart') + '.js').then(function (current) {
      var change = Discounts.update(current, discountProductIds(), PN.oneTimeDiscountCodes);
      if (change !== null) postJSON((PN.routes.cartUpdate || '/cart/update') + '.js', { discount: change })
        .then(function () { window.location.reload(); }).catch(PN.cartError);
    }).catch(PN.cartError);
  }

  /* ---------------- Menu drawer (tablet + mobile) ---------------- */
  (function () {
    var overlay = $('[data-menu]'); if (!overlay) return;
    var panel = overlay.querySelector('[data-menu-panel]');
    var openers = $$('[data-menu-open]');
    var lastFocus = null;
    function open() {
      lastFocus = document.activeElement;
      overlay.hidden = false;
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      document.body.style.overflow = 'hidden';
      var first = panel.querySelector('a, button'); if (first) first.focus();
    }
    function close() {
      if (overlay.hidden) return;
      overlay.hidden = true;
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    PN.openMenu = open; PN.closeMenu = close;
    openers.forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); open(); }); });
    overlay.addEventListener('click', function (e) { if (e.target.closest('[data-menu-close]')) close(); });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || overlay.hidden) { if (e.key === 'Escape') close(); return; }
      var items = $$('a[href], button:not([disabled])', panel); if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    if (window.matchMedia) {
      var mq = window.matchMedia('(min-width: 990px)');
      (mq.addEventListener ? mq.addEventListener.bind(mq, 'change') : mq.addListener.bind(mq))(function (ev) { if (ev.matches) close(); });
    }
  })();

  /* ---------------- Swipe rows (mobile; video stories also on tablet) ----------------
   * The CSS turns these grids into horizontal scroll-snap rows below 750px (video stories below 990px).
   * Here: mouse drag-to-scroll, and prev/next buttons that only appear while the row actually scrolls. */
  function wireSwipe(el) {
    if (el.getAttribute('data-swipe-wired')) return;
    el.setAttribute('data-swipe-wired', '1');
    var down = false, sx = 0, sl = 0, moved = false;
    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || el.scrollWidth <= el.clientWidth + 4) return;
      down = true; moved = false; sx = e.clientX; sl = el.scrollLeft;
      el.style.cursor = 'grabbing'; el.style.scrollSnapType = 'none';
    });
    el.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - sx; if (Math.abs(dx) > 4) moved = true;
      el.scrollLeft = sl - dx;
    });
    function up() { if (!down) return; down = false; el.style.cursor = ''; el.style.scrollSnapType = ''; }
    el.addEventListener('pointerup', up); el.addEventListener('pointerleave', up);
    el.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);

    var nav = document.createElement('div');
    nav.className = 'swipe-nav'; nav.setAttribute('aria-hidden', 'true');
    function mk(dir, icon) {
      var b = document.createElement('button'); b.type = 'button'; b.tabIndex = -1;
      b.setAttribute('aria-label', dir < 0 ? ((PN.strings && PN.strings.previous) || 'Previous') : ((PN.strings && PN.strings.next) || 'Next'));
      b.innerHTML = '<svg class="ic" aria-hidden="true" focusable="false"><use href="#i-' + icon + '"/></svg>';
      b.addEventListener('click', function () {
        var first = el.firstElementChild;
        var step = (first ? first.getBoundingClientRect().width : el.clientWidth * 0.8) + 12;
        el.scrollBy({ left: dir * step, behavior: 'smooth' });
      });
      return b;
    }
    var prev = mk(-1, 'chev-left'), next = mk(1, 'chev-right');
    nav.appendChild(prev); nav.appendChild(next);
    el.parentNode.insertBefore(nav, el.nextSibling);
    function sync() {
      var scrollable = el.scrollWidth > el.clientWidth + 4;
      nav.classList.toggle('is-scrollable', scrollable);
      if (!scrollable) return;
      prev.disabled = el.scrollLeft <= 4;
      next.disabled = el.scrollLeft + el.clientWidth >= el.scrollWidth - 2;
    }
    el.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    if ('ResizeObserver' in window) new ResizeObserver(sync).observe(el);
    if ('MutationObserver' in window) new MutationObserver(function () { sync(); }).observe(el, { childList: true });
    sync();
  }
  PN.wireSwipes = function () { $$('[data-swipe]').forEach(wireSwipe); };
  PN.wireSwipes();

  /* ---------------- Product page: sticky add-to-cart bar (tablet + mobile) ----------------
   * Visible while the inline add-to-cart button is off screen; CSS hides it from 990px up. */
  $$('[data-pdp-bar]').forEach(function (bar) {
    var root = bar.closest('[data-purchase]') || document;
    var form = root.querySelector('[data-pn-form]'); if (!form) return;
    var inline = form.querySelector('[type="submit"]') || form;
    function show(on) { bar.hidden = !on; document.body.classList.toggle('has-pdp-bar', on); }
    var btn = bar.querySelector('[type="submit"]');
    form.addEventListener('submit', function () { if (btn) { btn.disabled = true; setTimeout(function () { btn.disabled = false; }, 1500); } });
    if (!('IntersectionObserver' in window)) { show(true); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { show(!en.isIntersecting); });
    }, { threshold: 0 });
    io.observe(inline);
  });

  /* ---------------- Accordion (single open) ---------------- */
  $$('[data-accordion]').forEach(function (acc) {
    acc.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-accordion-btn]'); if (!btn) return;
      var panel = $('#' + btn.getAttribute('aria-controls'));
      var open = btn.getAttribute('aria-expanded') === 'true';
      $$('[data-accordion-btn]', acc).forEach(function (b) {
        var p = $('#' + b.getAttribute('aria-controls'));
        b.setAttribute('aria-expanded', 'false'); if (p) p.hidden = true;
      });
      if (!open) { btn.setAttribute('aria-expanded', 'true'); if (panel) panel.hidden = false; }
    });
  });

  /* ---------------- Gallery ---------------- */
  $$('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('.gallery__main img');
    var thumbs = $$('[data-gallery-thumb]', g);
    if (!main || !thumbs.length) return;
    var idx = 0;
    function show(i) {
      idx = (i + thumbs.length) % thumbs.length;
      var t = thumbs[idx];
      main.removeAttribute('srcset'); main.removeAttribute('sizes');
      main.src = t.getAttribute('data-src'); main.alt = t.getAttribute('data-alt') || '';
      thumbs.forEach(function (b, j) { if (j === idx) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); });
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
    var prev = g.querySelector('[data-gallery-prev]'), next = g.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { show(idx - 1); });
    if (next) next.addEventListener('click', function () { show(idx + 1); });
  });

  /* ---------------- Reviews: filter + column layout ---------------- */
  $$('[data-reviews]').forEach(function (root) {
    var grid = root.querySelector('[data-review-grid]');
    var cards = grid ? $$('.review-card', grid) : [];
    var pool = document.createElement('div'); pool.hidden = true; pool.setAttribute('data-review-pool', '');
    if (grid) grid.parentNode.insertBefore(pool, grid.nextSibling);
    cards.forEach(function (c, i) { c.setAttribute('data-idx', i); });

    function arrange(cat) {
      var stories = $$('[data-stories] .story', root); var shown = 0;
      stories.forEach(function (st) {
        var ok = (cat === 'All' || st.getAttribute('data-cat') === cat) && shown < 2;
        st.hidden = !ok;
        if (ok) { st.classList.toggle('story--flip', shown % 2 === 1); shown++; }
      });
      if (!grid) return;
      var filtered = cards.filter(function (c) { return cat === 'All' || c.getAttribute('data-cat') === cat; });
      var withPhoto = filtered.filter(function (c) { return c.getAttribute('data-has-img') === '1'; });
      var noPhoto = filtered.filter(function (c) { return c.getAttribute('data-has-img') !== '1'; });
      var cols = []; var pi = 0, ti = 0;
      while (cols.length < 3 && (pi < withPhoto.length || ti < noPhoto.length)) {
        var wantText = cols.length === 1 || pi >= withPhoto.length;
        if (wantText && ti < noPhoto.length) { cols.push({ text: true, items: noPhoto.slice(ti, ti + 2) }); ti += 2; }
        else if (pi < withPhoto.length) { cols.push({ text: false, items: [withPhoto[pi]] }); pi += 1; }
        else break;
      }
      cards.forEach(function (c) { pool.appendChild(c); });
      $$('.review-col', grid).forEach(function (c) { c.remove(); });
      cols.forEach(function (col) {
        if (col.text) { var wrap = document.createElement('div'); wrap.className = 'review-col'; col.items.forEach(function (c) { wrap.appendChild(c); }); grid.appendChild(wrap); }
        else grid.appendChild(col.items[0]);
      });
    }
    root.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-filter]');
      if (chip) {
        $$('[data-filter]', root).forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
        arrange(chip.getAttribute('data-filter'));
        return;
      }
      var more = e.target.closest('[data-more]');
      if (more) {
        var card = more.closest('.review-card');
        var open = card.classList.toggle('is-open');
        more.setAttribute('aria-expanded', open ? 'true' : 'false');
        more.textContent = open ? 'Read less' : 'Read more';
      }
    });
    arrange('All');
  });

  /* ---------------- Ingredient loop (infinite, draggable) ---------------- */
  $$('[data-loop]').forEach(function (el) {
    var wrap = el.parentNode;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var inited = false;
    function init() {
      if (inited || el.scrollWidth === 0) return;
      el.scrollLeft = el.scrollWidth / 3; inited = true;
    }
    init();
    var tries = 0; var iv = setInterval(function () { init(); if (inited || ++tries > 40) clearInterval(iv); }, 100);
    el.addEventListener('scroll', function () {
      var third = el.scrollWidth / 3;
      if (el.scrollLeft >= third * 2) el.scrollLeft -= third;
      else if (el.scrollLeft < third * 0.5) el.scrollLeft += third;
    });
    el.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) { el.scrollLeft += e.deltaY; e.preventDefault(); }
    }, { passive: false });
    var drag = null;
    el.addEventListener('pointerdown', function (e) {
      drag = { x: e.clientX, left: el.scrollLeft };
      if (el.setPointerCapture) el.setPointerCapture(e.pointerId);
      el.classList.add('is-dragging');
    });
    el.addEventListener('pointermove', function (e) { if (drag) el.scrollLeft = drag.left - (e.clientX - drag.x); });
    function up() { drag = null; el.classList.remove('is-dragging'); }
    el.addEventListener('pointerup', up); el.addEventListener('pointercancel', up);
    el.addEventListener('click', function (e) { if (drag === null && e.detail === 0) return; }, true);
    function by(dir) { el.scrollBy({ left: dir * Math.min(el.clientWidth * 0.6, 600), behavior: reduce ? 'auto' : 'smooth' }); }
    var prev = wrap.querySelector('[data-loop-prev]'), next = wrap.querySelector('[data-loop-next]');
    if (prev) prev.addEventListener('click', function () { by(-1); });
    if (next) next.addEventListener('click', function () { by(1); });
  });

  /* ---------------- Blog: load more via Section Rendering API ---------------- */
  $$('[data-learn-more]').forEach(function (more) {
    var btn = more.querySelector('[data-learn-more-btn]');
    var loading = more.querySelector('[data-learn-loading]');
    var blocks = $('[data-learn-blocks]');
    if (!btn || !blocks || !window.fetch) return;
    var busy = false;
    function load() {
      if (busy) return; busy = true;
      var url = more.getAttribute('data-next-url');
      var sectionId = more.getAttribute('data-section-id');
      if (!url) return;
      btn.hidden = true; if (loading) loading.hidden = false;
      var sep = url.indexOf('?') >= 0 ? '&' : '?';
      fetch(url + sep + 'section_id=' + encodeURIComponent(sectionId), { headers: { Accept: 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var incoming = doc.querySelector('[data-learn-blocks]');
          var nextMore = doc.querySelector('[data-learn-more]');
          if (incoming) Array.prototype.slice.call(incoming.children).forEach(function (c) { blocks.appendChild(c); });
          PN.wireSwipes();
          if (nextMore && nextMore.getAttribute('data-next-url')) {
            more.setAttribute('data-next-url', nextMore.getAttribute('data-next-url'));
            btn.setAttribute('href', nextMore.getAttribute('data-next-url'));
            btn.hidden = false;
          } else { more.hidden = true; }
          if (window.history && window.history.replaceState) window.history.replaceState(null, '', url);
        })
        .catch(function () { window.location.href = url; })
        .then(function () { if (loading) loading.hidden = true; busy = false; });
    }
    btn.addEventListener('click', function (e) { e.preventDefault(); load(); });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) { if (entries.some(function (en) { return en.isIntersecting; }) && !more.hidden) load(); }, { rootMargin: '200px 0px' });
      io.observe(more);
    }
  });

  /* ---------------- Toast: view cart ---------------- */
  document.addEventListener('pn:cart-added', function () { PN.toast((PN.strings && PN.strings.addedToCart) || 'Added to cart'); });
})();
